export default "__VITE_ASSET__BX2lz$3c__"